import { render, staticRenderFns } from "./authRule.vue?vue&type=template&id=e0517422&scoped=true&"
import script from "./authRule.vue?vue&type=script&lang=js&"
export * from "./authRule.vue?vue&type=script&lang=js&"
import style0 from "./authRule.vue?vue&type=style&index=0&id=e0517422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0517422",
  null
  
)

export default component.exports